module.exports = __webpack_public_path__ + "static/Maruthi Suzuki Ciaz-26df69044ae09aa16ed9bea9b613e95e.png";